import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import request from 'utils/request_ajax.js';
import { routes as ROUTES } from 'constants/config';
import * as selectors from 'selectors/pathBuilder';
import * as actions from '../../../actions/pathBuilder';
import Section, { SectionHeader } from './Section';
import SaveButton from './partials/SaveButton';

class CompletionOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enforcedOrder: this.props.enforcedOrder,
    };
    this.handleSave = this.handleSave.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.enforcedOrder !== nextProps.enforcedOrder) {
      this.setState({ enforcedOrder: nextProps.enforcedOrder });
    }
  }

  onRadioChange({ target }) {
    this.setState({
      [target.name]: JSON.parse(target.value),
    });
  }

  handleSave() {
    const change = { enforcedOrder: this.state.enforcedOrder };
    if (this.props.pathId) {
      this.setState({ loading: true }, () => {
        request
          .put(ROUTES.PATHS + `/${this.props.pathId}`, change)
          .then(res => {
            this.props.updatePath({ enforcedOrder: res.enforcedOrder });
            this.setState({ loading: false }, this.props.toggleEditing);
          });
      });
    } else {
      this.props.updatePath(change);
      this.props.toggleEditing();
    }
  }

  static labels = {
    true: 'Steps must be taken in order',
    false: 'Steps can be taken in any order',
  };

  render() {
    const { userCanEditContent } = this.props;

    const Radio = ({ value, name, label }) => (
      <label htmlFor={`${name}.${value}`}>
        <input
          checked={this.state.enforcedOrder === value}
          id={`${name}.${value}`}
          name={name}
          onChange={this.onRadioChange}
          type="radio"
          value={value}
        />
        <span className="ml-8">{label}</span>
      </label>
    );

    return (
      <Section>
        <SectionHeader className="d-f jc-sb" htmlFor="pathDescription">
          Step Order
          {!this.props.isArchived && !this.props.editing && userCanEditContent && (
            <button
              type="button"
              className="u-linkBtn fz-base fw-n"
              onClick={this.props.toggleEditing}
            >
              <Icon name="edit" className="mr-4" />
              Edit
            </button>
          )}
        </SectionHeader>
        {!this.props.editing && (
          <div className="c-brand-gray-darker">
            {CompletionOrder.labels[this.props.enforcedOrder]}
          </div>
        )}
        {this.props.editing && (
          <div>
            <Radio
              name="enforcedOrder"
              value={true}
              label={CompletionOrder.labels.true}
            />
            <Radio
              name="enforcedOrder"
              value={false}
              label={CompletionOrder.labels.false}
            />
            <div className="d-f jc-e ai-c mt-8">
              <button
                type="button"
                className="u-linkBtn u-linkBtn--dark td-u"
                onClick={this.props.toggleEditing}
                children="Cancel"
              />
              <SaveButton
                loading={this.state.loading}
                onClick={this.handleSave}
              />
            </div>
          </div>
        )}
      </Section>
    );
  }
}

const mapStateToProps = ({ pathBuilder, meta }) => ({
  pathId: pathBuilder.id,
  enforcedOrder: pathBuilder.enforcedOrder,
  editing: pathBuilder.editingOrderEnforcement,
  isArchived: selectors.isArchived(pathBuilder),
  userCanEditContent: pathBuilder.permissions.editPath,
});

const mapDispatchToProps = {
  toggleEditing: actions.toggleEditingOrderEnforcement,
  updatePath: actions.updatePath,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompletionOrder);
